<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Nm94/tc-custom/9781399008693.jpg?1718072593887" alt="This image is the cover for the book 614th Tank Destroyer Battalion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">614th Tank Destroyer Battalion
      </h1>
      <p class="bookDescription body article font2">
        <p>Finalist, 2022 Army Historical Foundation Distinguished Writing Awards<br/><br/>The 614th Tank Destroyer Battalion was activated on 25 July 1942 at Camp Carson, USA and, like many other tank destroyer battalions, would be sent to Europe. It saw combat in France, where a platoon earned the Distinguished Unit Citation, and later continued to fight gallantly in Germany and Austria until the war was over.  However, unlike many other tank destroyer battalions that fought in the Second World War, this unit was crewed only by black soldiers. The men had been subjected to racism from their countrymen during training, although the battalion did eventually win the respect of the white soldiers they fought alongside. When the third platoon deployed their guns on the slopes near Climbach, France, they weren’t just fighting against the Germans, but also against any prejudices that their white countrymen might have had.  Having earned the respect of the 103d Infantry Division, the 614th Tank Destroyer Battalion shared in their triumphs and tragedies. So when the division needed to retreat during a blizzard, or when Task Force Rhine pushed its way across the German plains, or when the division suffered heavy losses at Schillersdorf, the 614th Tank Destroyer Battalion was there with them.  Included in this book are lists of medals awarded to the men during the war, as well as a list of casualties and those that served in the unit.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Samuel de Korte
      </h2>
      
      <p class="authorDescription body article">Samuel de Korte is a graduate of Utrecht University, where he received an MA in the Cultural History of Modern Europe, and in his spare time enjoys researching or writing articles about popular history. He wrote his thesis about the representation of Black Americans during the Second World War in contemporary media, indicating that although they formed a substantial part of the American armed forces, they don't receive an equal share in the representation. His research provided the starting point for this book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef30c3bc